import {Component, h} from 'preact';
import {setVisualMode} from './Store/creators/common';
import {dispatch} from './Store/index';

/**
 * Component Properties.
 */
interface MobileVisualVerticalProps
{
	/** Путь до фонового изображения */
	background: string;
}

/**
 * Component State.
 */
interface MobileVisualVerticalState
{
	[key: string]: void;
}

/**
 * Вертикальный визуальный режим на мобильном.
 */
class MobileVisualVertical extends Component<MobileVisualVerticalProps, MobileVisualVerticalState>
{
	/**
	 * Класс, добавляемый на body при визуальном режиме.
	 */
	private static readonly CLASS_BODY_VERTICAL = 'vertical';
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		document.body.classList.add( MobileVisualVertical.CLASS_BODY_VERTICAL );
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		document.body.classList.remove( MobileVisualVertical.CLASS_BODY_VERTICAL );
	}
	
	/**
	 * Render component.
	 */
	public render( {background}: MobileVisualVerticalProps ): JSX.Element
	{
		return (
			<div class="visual vertical">
				<img
					class="background"
					src={background}
					alt=""
				/>
				<p class="message">
					Переверните устройство в горизонтальное положение для выбора квартиры на плане, или
					{' '}
					<button
						type="button"
						class="view-list"
						onClick={this.onViewListClick}
					>
						Выберите из списка
					</button>
				</p>
			</div>
		);
	}
	
	/**
	 * При нажатии на «Квартиры списком».
	 */
	protected onViewListClick = (): void =>
	{
		dispatch( setVisualMode( false ) );
	}
}

/**
 * Module.
 */
export {
	MobileVisualVertical as default,
	MobileVisualVerticalProps,
	MobileVisualVerticalState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/MobileVisualVertical.tsx